
const PurchaseStyles = (theme) => ({
    rootTab: {
        backgroundColor: theme.palette.background.paper,
        width: 500,
    },
    root: {
        backgroundColor: 'white',
        border: '1px solid #6D6E6E',
        marginTop: '-10px'
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
    containerWithBorder: {
        backgroundColor: 'white',
        border: 'solid',
        borderWidth: 'thin'
    },
    containerWithBorderRound: {
        backgroundColor: 'white',
        border: 'solid',
        borderWidth: 'thin',
        borderRadius: '0px',
    },
    cardHeader: {
        backgroundColor: '#7AA4D5',
        color: "white"
    },
    cardHeaderDisabled: {
        backgroundColor: '#b4bfcd',
        color: "white"
    },
    subHeaderPadding: {
        padding: 'px',
    },
    dashboardAlign: {
        textAlign: 'center',
    },
    dashboardIcon: {
        fontSize: '40px',
        color: '#79ba00'
    },
    dashboardIconDisabled: {
        fontSize: '40px',
        color: '#9eb17b'
    },
    alignCenter: {
        textAlign: 'center',
    },
    alignRight: {
        textAlign: 'right',
    },
    alignLeft: {
        textAlign: 'left',
    },
    saveButtons:{
        textAlign: 'left',
        paddingLeft: 10

    },
    negativeSpacing: {
        padding: 30
    },
    searchAlign: {
        textAlign: 'right'
    },
    gridColorDefault: {
        border: 'solid',
        borderWidth: 'thin',
        borderRadius: '0px',
    },
    gridColor1: {
        backgroundColor: '  #7a9bc2 !important',
        border: 'solid',
        borderWidth: 'thin',
        borderRadius: '0px',
        textAlign: '-webkit-center'
    },
    gridColor2: {
        backgroundColor: '#d8d8d8 !important',
        border: 'solid',
        borderWidth: 'thin',
        borderRadius: '0px',
    },
    textColorWhite: {
        color: 'white'
    },
    toastSuccess: {
        background: '#82C341'
    },
    toastError: {
        background: '#BF2E2E'
    },
    tabsVertical: {
        borderRight: `1px solid ${theme.palette.divider}`,
    },
    tabsHorizontal: {
        borderBottom: `1px solid ${theme.palette.divider}`,
    },
    rootTabPanel: {
        flexGrow: 1,
        display: 'flex',
    },
    ButtonSave: {
        backgroundColor: '#84BD00',
        color: '#FFFFFF',
        border: '.5px solid #B1D82E;',
        '&:hover': {
            backgroundColor: '#73a204'
        }
    },
    generalBorder: {
        border: '1px solid #7A9BC2',
    },
    paddingTabPanel: {
        paddingLeft: '0px',
        paddingTop: '0px',
        paddingRight: '0px'
    },
    buttonAlign: {
        textAlign: 'right'
    },
    borderLeft: {
        borderLeft: '1px solid #7A9BC2'
    },
    subTitles: {
        color: 'white',
        background: '#7a9bc2',
        paddingTop: '5px',
        paddingLeft: '5px'
    },
    table: {
        headRow: {
            style: {
                border: 'none',
            },
        },
        headCells: {
            style: {
                color: '#202124',
                fontSize: '14px',
            },
        },
        rows: {
            highlightOnHoverStyle: {
                backgroundColor: 'rgb(230, 244, 244)',
                borderBottomColor: '#FFFFFF',
                borderRadius: '25px',
                outline: '1px solid #FFFFFF',
            },
        },
        pagination: {
            style: {
                border: 'none',
            },
        }
    },
    marginNoData: {
        margin: '25px'
    },
    borderRadius: {
        borderRadius: '0px'
    },
    text:{
        color: 'black'
    },
    textDisaled:{
        color: '#afb1b3'
    },
    tableTitleAP: {
        marginTop: '0.5em',
        marginBottom: '0',
        marginLeft: '0.5em',
        fontSize: '22px',
        color: 'black'
    },
    rejectedComment: {
        marginTop: '0.5em',
        marginBottom: '0',
        marginLeft: '0.5em',
        fontSize: '22px',
        color: 'red',
        textAlign: 'center'
    },
    labelWithIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end'
      },
    helpIcon: {
        marginLeft: theme.spacing(1),
        cursor: 'pointer',
    },
    tooltip: {
        backgroundColor: '#000',
        color: '#fff',
        fontSize: 12,
        boxShadow: theme.shadows[1],
    },
    arrow: {
        color: '#000'
      }
})

export default PurchaseStyles